
import {
  ApproveTimeAuxillaryDto,
  ApproveTimePayloadDto,
  CancelMealBreakAuxillaryDto,
  CancelMealBreakPayloadDto,
  CancelMealBreakResponseDto,
  CancelRestBreakAuxillaryDto,
  CancelRestBreakPayloadDto,
  ClockInAuxillaryDto,
  ClockInPayloadDto,
  ClockInResponseDto,
  ClockOutAuxillaryDto,
  ClockOutPayloadDto,
  ClockOutResponseDto,
  CreateClosedMealBreakTimePayloadDto,
  CreateClosedMealBreakTimeResponseDto,
  CreateClosedWorkingTimeAuxillaryDto,
  CreateClosedWorkingTimePayloadDto,
  CreateClosedWorkingTimeResponseDto,
  CreateFlexDocActivityAuxillaryDto,
  CreateFlexDocActivityPayloadDto,
  CreateFlexDocActivityResponseDto,
  CreateNotableActivityAuxillaryDto,
  CreateNotableActivityPayloadDto,
  CreateNotableActivityResponseDto,
  DeleteNotableActivityAuxillaryDto,
  DeleteNotableActivityPayloadDto,
  DeleteTimeAuxillaryDto,
  DeleteTimePayloadDto,
  EndMealBreakAuxillaryDto,
  EndMealBreakPayloadDto,
  EndMealBreakResponseDto,
  ReturnTimeAuxillaryDto,
  ReturnTimePayloadDto,
  StartMealBreakAuxillaryDto,
  StartMealBreakPayloadDto,
  StartMealBreakResponseDto,
  StartNewAssignmentAuxillaryDto,
  StartNewAssignmentPayloadDto,
  StartNewAssignmentResponseDto,
  SubmitTimeAuxillaryDto,
  SubmitTimePayloadDto,
  UpdateAssignmentAuxillaryDto,
  UpdateAssignmentPayloadDto,
  UpdateAssignmentResponseDto,
  UpdateNotableActivityAuxillaryDto,
  UpdateNotableActivityPayloadDto,
  UpdateTimeClocksAuxillaryDto,
  UpdateTimeClocksPayloadDto,
  VerifyTimeAuxillaryDto,
  VerifyTimePayloadDto,
  CreateClosedMealBreakTimeAuxillaryDto
} from "src/app/dtos/sync-action-service-dtos";
import { CreateOdometerReadingAuxillaryDto } from "src/app/dtos/sync-action-service-dtos/auxillary-dtos/create-odometer-reading-auxillary-dto";
import { DeleteOdometerReadingAuxillaryDto } from "src/app/dtos/sync-action-service-dtos/auxillary-dtos/delete-odometer-reading-auxillary-dto";
import { UpdateOdometerReadingAuxillaryDto } from "src/app/dtos/sync-action-service-dtos/auxillary-dtos/update-odometer-reading-auxillary-dto";
import { CreateOdometerReadingPayloadDto } from "src/app/dtos/sync-action-service-dtos/payload-dtos/create-odometer-reading-payload-dto";
import { DeleteOdometerReadingPayloadDto } from "src/app/dtos/sync-action-service-dtos/payload-dtos/delete-odometer-reading-payload-dto";
import { UpdateOdometerReadingPayloadDto } from "src/app/dtos/sync-action-service-dtos/payload-dtos/update-odometer-reading-payload-dto";
import { CreateOdometerReadingResponseDto } from "src/app/dtos/sync-action-service-dtos/response-dtos/create-odometer-reading-response-dto";
import { UpdateOdometerReadingResponseDto } from "src/app/dtos/sync-action-service-dtos/response-dtos/update-odometer-reading-response-dto";
import { CreateClosedRestBreakTimeAuxillaryDto } from "src/app/dtos/sync-action-service-dtos/auxillary-dtos/create-closed-rest-break-time-auxillary-data-dto";
import { StartRestBreakAuxillaryDto } from "src/app/dtos/sync-action-service-dtos/auxillary-dtos/start-rest-break-auxillary-dto";
import { CreateClosedRestBreakTimePayloadDto } from "src/app/dtos/sync-action-service-dtos/payload-dtos/create-closed-rest-break-time-payload-dto";
import { StartRestBreakPayloadDto } from "src/app/dtos/sync-action-service-dtos/payload-dtos/start-rest-break-payload-dto";
import { CreateClosedRestBreakTimeResponseDto } from "src/app/dtos/sync-action-service-dtos/response-dtos/create-closed-rest-break-time-response-dto";
import { StartRestBreakResponseDto } from "src/app/dtos/sync-action-service-dtos/response-dtos/start-rest-break-response-dto";
import { CompletedSyncAction, SavedSyncAction } from "src/app/models/sync-action/sync-action-interface";
import { ServiceInjections, ServiceNames, SyncActionType } from "src/app/models/sync-action/sync-action-types-interface";
import { DependantSyncActionException } from "src/app/utils/exceptions";
import { HttpMethod } from "src/app/utils/http/http-method";
import { environment } from "src/environments/environment";

/**
 * Enum for sync action type IDs.
 * IMPORTANT: Do not modify existing values as they are used in the database.
 */
export enum SyncActionTypeId {
  ClockIn = 'ClockIn',
  StartMealBreak = 'StartMealBreak',
  EndMealBreak = "EndBreak",
  CancelMealBreak = 'CancelMealBreak',
  StartRestBreak = "StartRestBreak",
  CancelRestBreak = 'CancelRestBreak',
  ClockOut = 'ClockOut',
  CreateNotableActivity = 'CreateNotableActivity',
  UpdateNotableActivity = 'UpdateNotableActivity',
  CreateFlexDocActivity = 'CreateFlexDocActivity',
  StartNewAssignment = "StartNewAssignment",
  CreateClosedWorkingTime = 'CreateClosedWorkingTime',
  CreateClosedMealBreakTime = 'CreateClosedMealBreakTime',
  CreateClosedRestBreakTime = 'CreateClosedRestBreakTime',
  UpdateTimeClocks = "UpdateTimeClocks",
  UpdateAssignment = "UpdateAssignment",
  SubmitTime = "SubmitTime",
  VerifyTime = 'VerifyTime',
  ApproveTime = 'ApproveTime',
  ReturnTime = 'ReturnTime',
  DeleteTime = "DeleteTime",
  DeleteNotableActivity = "DeleteNotableActivity",
  CreateOdometerReading = 'CreateOdometerReading',
  UpdateOdometerReading = 'UpdateOdometerReading',
  DeleteOdometerReading = 'DeleteOdometerReading',
}

export type SyncActionTypeData = {
  [SyncActionTypeId.ClockIn]: {
    params: null,
    auxillaryData: ClockInAuxillaryDto,
    payload: ClockInPayloadDto,
    response: ClockInResponseDto,
  },
  [SyncActionTypeId.StartMealBreak]: {
    params: { openTimeRecordId: number },
    auxillaryData: StartMealBreakAuxillaryDto,
    payload: StartMealBreakPayloadDto,
    response: StartMealBreakResponseDto,
  },
  [SyncActionTypeId.EndMealBreak]: {
    params: { openTimeRecordId: number },
    auxillaryData: EndMealBreakAuxillaryDto,
    payload: EndMealBreakPayloadDto,
    response: EndMealBreakResponseDto,
  },
  [SyncActionTypeId.CancelMealBreak]: {
    params: { openTimeRecordId: number },
    auxillaryData: CancelMealBreakAuxillaryDto,
    payload: CancelMealBreakPayloadDto,
    response: CancelMealBreakResponseDto,
  },
  [SyncActionTypeId.StartRestBreak]: {
    params: { openTimeRecordId: number },
    auxillaryData: StartRestBreakAuxillaryDto,
    payload: StartRestBreakPayloadDto,
    response: StartRestBreakResponseDto,
  },
  [SyncActionTypeId.CancelRestBreak]: {
    params: { timeRecordId: number },
    auxillaryData: CancelRestBreakAuxillaryDto,
    payload: CancelRestBreakPayloadDto,
    response: null,
  },
  [SyncActionTypeId.StartNewAssignment]: {
    params: { openTimeRecordId: number },
    auxillaryData: StartNewAssignmentAuxillaryDto,
    payload: StartNewAssignmentPayloadDto,
    response: StartNewAssignmentResponseDto,
  },
  [SyncActionTypeId.ClockOut]: {
    params: { openTimeRecordId: number },
    auxillaryData: ClockOutAuxillaryDto,
    payload: ClockOutPayloadDto,
    response: ClockOutResponseDto,
  },
  [SyncActionTypeId.CreateClosedWorkingTime]: {
    params: null,
    auxillaryData: CreateClosedWorkingTimeAuxillaryDto,
    payload: CreateClosedWorkingTimePayloadDto,
    response: CreateClosedWorkingTimeResponseDto,
  },
  [SyncActionTypeId.CreateClosedMealBreakTime]: {
    params: null,
    auxillaryData: CreateClosedMealBreakTimeAuxillaryDto,
    payload: CreateClosedMealBreakTimePayloadDto,
    response: CreateClosedMealBreakTimeResponseDto,
  },
  [SyncActionTypeId.CreateClosedRestBreakTime]: {
    params: null,
    auxillaryData: CreateClosedRestBreakTimeAuxillaryDto,
    payload: CreateClosedRestBreakTimePayloadDto,
    response: CreateClosedRestBreakTimeResponseDto,
  },
  [SyncActionTypeId.UpdateTimeClocks]: {
    params: { timeRecordId: number },
    auxillaryData: UpdateTimeClocksAuxillaryDto,
    payload: UpdateTimeClocksPayloadDto,
    response: null,
  },
  [SyncActionTypeId.UpdateAssignment]: {
    params: { timeRecordId: number },
    auxillaryData: UpdateAssignmentAuxillaryDto,
    payload: UpdateAssignmentPayloadDto,
    response: UpdateAssignmentResponseDto,
  },
  [SyncActionTypeId.CreateNotableActivity]: {
    params: null,
    auxillaryData: CreateNotableActivityAuxillaryDto,
    payload: CreateNotableActivityPayloadDto,
    response: CreateNotableActivityResponseDto,
  },
  [SyncActionTypeId.UpdateNotableActivity]: {
    params: { activityId: number},
    auxillaryData: UpdateNotableActivityAuxillaryDto,
    payload: UpdateNotableActivityPayloadDto,
    response: null,
  },
  [SyncActionTypeId.CreateFlexDocActivity]: {
    params: null,
    auxillaryData: CreateFlexDocActivityAuxillaryDto,
    payload: CreateFlexDocActivityPayloadDto,
    response: CreateFlexDocActivityResponseDto,
  },
  [SyncActionTypeId.SubmitTime]: {
    params: { activityLogId: number },
    auxillaryData: SubmitTimeAuxillaryDto,
    payload: SubmitTimePayloadDto,
    response: null,
  },
  [SyncActionTypeId.VerifyTime]: {
    params: { activityLogId: number },
    auxillaryData: VerifyTimeAuxillaryDto,
    payload: VerifyTimePayloadDto,
    response: null,
  },
  [SyncActionTypeId.ApproveTime]: {
    params: { activityLogId: number },
    auxillaryData: ApproveTimeAuxillaryDto,
    payload: ApproveTimePayloadDto,
    response: null,
  },
  [SyncActionTypeId.ReturnTime]: {
    params: { activityLogId: number },
    auxillaryData: ReturnTimeAuxillaryDto,
    payload: ReturnTimePayloadDto,
    response: null,
  },
  [SyncActionTypeId.DeleteTime]: {
    params: { timeRecordId: number },
    auxillaryData: DeleteTimeAuxillaryDto,
    payload: DeleteTimePayloadDto,
    response: null,
  },
  [SyncActionTypeId.DeleteNotableActivity]: {
    params: { activityId: number },
    auxillaryData: DeleteNotableActivityAuxillaryDto,
    payload: DeleteNotableActivityPayloadDto,
    response: null,
  },
  [SyncActionTypeId.CreateOdometerReading]: {
    params: null,
    auxillaryData: CreateOdometerReadingAuxillaryDto,
    payload: CreateOdometerReadingPayloadDto,
    response: CreateOdometerReadingResponseDto,
  },
  [SyncActionTypeId.UpdateOdometerReading]: {
    params: { odometerReadingId: number },
    auxillaryData: UpdateOdometerReadingAuxillaryDto,
    payload: UpdateOdometerReadingPayloadDto,
    response: UpdateOdometerReadingResponseDto,
  },
  [SyncActionTypeId.DeleteOdometerReading]: {
    params: { odometerReadingId: number },
    auxillaryData: DeleteOdometerReadingAuxillaryDto,
    payload: DeleteOdometerReadingPayloadDto,
    response: null,
  }
};

export const SyncActionTypes: Record<SyncActionTypeId, SyncActionType<SyncActionTypeId>> = {
  [SyncActionTypeId.ClockIn]: {
    id: SyncActionTypeId.ClockIn,
    description: 'Clock In',
    url: environment.timeApiUrl + '/time/time-records/clock-in',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.ClockIn>) => {
      await serviceInjections.timeSyncService.onClockInDoBefore(action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ClockIn>) => {
      await serviceInjections.timeSyncService.onClockInSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ClockIn>) => {
      await serviceInjections.timeSyncService.onClockInFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.StartMealBreak]:  {
    id: SyncActionTypeId.StartMealBreak,
    description: 'Start Meal Break',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/start-meal-break',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.StartMealBreak>) => {
        await serviceInjections.timeSyncService.onStartMealBreakDoBefore(serviceInjections, action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartMealBreak>) => {
      await serviceInjections.timeSyncService.onStartMealBreakSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartMealBreak>) => {
      await serviceInjections.timeSyncService.onStartMealBreakFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.EndMealBreak]:  {
    id: SyncActionTypeId.EndMealBreak,
    description: 'End Meal Break',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/end-meal-break',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.EndMealBreak>) => {
      await serviceInjections.timeSyncService.onEndMealBreakDoBefore(serviceInjections, action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.EndMealBreak>) => {
      await serviceInjections.timeSyncService.onEndMealBreakSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.EndMealBreak>) => {
      await serviceInjections.timeSyncService.onEndMealBreakFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CancelMealBreak]:  {
    id: SyncActionTypeId.CancelMealBreak,
    description: 'Cancel Meal Break',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/cancel-meal-break',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.CancelMealBreak>) => {
      if (!action.params.openTimeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.openTimeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CancelMealBreak>) => {
      await serviceInjections.timeSyncService.onCancelMealBreakSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CancelMealBreak>) => {
      await serviceInjections.timeSyncService.onCancelMealBreakFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.StartRestBreak]:  {
    id: SyncActionTypeId.StartRestBreak,
    description: 'Start Rest Break',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/closed-rest-break',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.StartRestBreak>) => {
      if (!action.params.openTimeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.openTimeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartRestBreak>) => {
      await serviceInjections.timeSyncService.onStartRestBreakSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartRestBreak>) => {
      await serviceInjections.timeSyncService.onStartRestBreakFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CancelRestBreak]:  {
    id: SyncActionTypeId.CancelRestBreak,
    description: 'Cancel Rest Break',
    url: environment.timeApiUrl + '/time/time-records/{timeRecordId}/cancel-rest-break',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.CancelRestBreak>) => {
      if (!action.params.timeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingBreakTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.timeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CancelRestBreak>) => {
      await serviceInjections.timeSyncService.onCancelRestBreakSuccess(action.auxillaryData);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CancelRestBreak>) => {
      await serviceInjections.timeSyncService.onCancelRestBreakFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.StartNewAssignment]:  {
    id: SyncActionTypeId.StartNewAssignment,
    description: 'Start New Assignment',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/start-new-assignment',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.StartNewAssignment>) => {
      await serviceInjections.timeSyncService.onStartNewAssignmentDoBefore(serviceInjections, action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartNewAssignment>) => {
      await serviceInjections.timeSyncService.onStartNewAssignmentSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.StartNewAssignment>) => {
      await serviceInjections.timeSyncService.onStartNewAssignmentFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.ClockOut]: {
    id: SyncActionTypeId.ClockOut,
    description: 'Clock Out',
    url: environment.timeApiUrl + '/time/time-records/{openTimeRecordId}/clock-out',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService, ServiceNames.OdometerReadingMediaService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.ClockOut>) => {
      await serviceInjections.timeSyncService.onClockOutDoBefore(serviceInjections, action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ClockOut>) => {
      await serviceInjections.timeSyncService.onClockOutSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ClockOut>) => {
      await serviceInjections.timeSyncService.onClockOutFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateClosedWorkingTime]: {
    id: SyncActionTypeId.CreateClosedWorkingTime,
    description: 'Create Closed Working Time',
    url: environment.timeApiUrl + '/time/closed-working-time',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedWorkingTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedWorkingTimeSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedWorkingTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedWorkingTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateClosedMealBreakTime]: {
    id: SyncActionTypeId.CreateClosedMealBreakTime,
    description: 'Create Closed Break Time',
    url: environment.timeApiUrl + '/time/closed-meal-break-time',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedMealBreakTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedMealBreakTimeSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedMealBreakTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedMealBreakTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateClosedRestBreakTime]: {
    id: SyncActionTypeId.CreateClosedRestBreakTime,
    description: 'Create Closed Rest Break Time',
    url: environment.timeApiUrl + '/time/closed-rest-break-time',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedRestBreakTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedRestBreakTimeSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateClosedRestBreakTime>) => {
      await serviceInjections.timeSyncService.onCreateClosedRestBreakTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.UpdateTimeClocks]: {
    id: SyncActionTypeId.UpdateTimeClocks,
    description: 'Update Time Clocks',
    url: environment.timeApiUrl + '/time/time-records/{timeRecordId}/update-clocks',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.UpdateTimeClocks>) => {
      if (!action.params.timeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.timeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateTimeClocks>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateTimeClocks>) => {
      await serviceInjections.timeSyncService.onUpdateTimeClocksFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.UpdateAssignment]: {
    id: SyncActionTypeId.UpdateAssignment,
    description: 'Update Assignment',
    url: environment.timeApiUrl + '/time/time-records/{timeRecordId}/update-assignment',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.UpdateAssignment>) => {
      if (!action.params.timeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.timeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateAssignment>) => {
      await serviceInjections.timeSyncService.onUpdateAssignmentSuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateAssignment>) => {
      await serviceInjections.timeSyncService.onUpdateAssignmentFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateNotableActivity]: {
    id: SyncActionTypeId.CreateNotableActivity,
    description: 'Create Notable Activity',
    url: environment.timeApiUrl + '/time/notable-activities',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateNotableActivity>) => {
      await serviceInjections.timeSyncService.onCreateNotableActivitySuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateNotableActivity>) => {
      await serviceInjections.timeSyncService.onCreateNotableActivityFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.UpdateNotableActivity]: {
    id: SyncActionTypeId.UpdateNotableActivity,
    description: 'Update Notable Activity',
    url: environment.timeApiUrl + '/time/notable-activities/{activityId}',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.UpdateNotableActivity>) => {
      if (!action.params.activityId) {
        const activity = await serviceInjections.activityService.getActivityByRecordId(action.auxillaryData.ExistingActivity.RecordId, null, true);
        if (!activity?.Id) {
          throw new DependantSyncActionException(activity);
        }
        action.params.activityId = activity.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateNotableActivity>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateNotableActivity>) => {
      await serviceInjections.timeSyncService.onUpdateNotableActivityFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateFlexDocActivity]: {
    id: SyncActionTypeId.CreateFlexDocActivity,
    description: 'Create Flex Doc Activity',
    url: environment.timeApiUrl + '/time/flex-doc-activities',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService],
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateFlexDocActivity>) => {
      await serviceInjections.timeSyncService.onCreateFlexDocActivitySuccess(action.auxillaryData, action.response);
    },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateFlexDocActivity>) => {
      await serviceInjections.timeSyncService.onCreateFlexDocActivityFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.SubmitTime]: {
    id: SyncActionTypeId.SubmitTime,
    description: 'Submit Time',
    url: environment.timeApiUrl + '/time/activity-logs/{activityLogId}/submit',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityLogService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.SubmitTime>) => {
      if (!action.params.activityLogId) {
        const activityLog = await serviceInjections.activityLogService.getActivityLogByRecordId(action.auxillaryData.ExistingRecords.RecordId, null, true);
        if (!activityLog?.Id) {
          throw new DependantSyncActionException(activityLog);
        }
        action.params.activityLogId = activityLog.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.SubmitTime>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.SubmitTime>) => {
      await serviceInjections.timeSyncService.onSubmitTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.VerifyTime]: {
    id: SyncActionTypeId.VerifyTime,
    description: 'Verify Time',
    url: environment.timeApiUrl + '/time/activity-logs/{activityLogId}/verify',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityLogService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.SubmitTime>) => {
      if (!action.params.activityLogId) {
        const activityLog = await serviceInjections.activityLogService.getActivityLogByRecordId(action.auxillaryData.ExistingRecords.RecordId, null, true);
        if (!activityLog?.Id) {
          throw new DependantSyncActionException(activityLog);
        }
        action.params.activityLogId = activityLog.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.VerifyTime>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.VerifyTime>) => {
      await serviceInjections.timeSyncService.onVerifyTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.ApproveTime]: {
    id: SyncActionTypeId.ApproveTime,
    description: 'Approve Time',
    url: environment.timeApiUrl + '/time/activity-logs/{activityLogId}/approve',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityLogService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.SubmitTime>) => {
      if (!action.params.activityLogId) {
        const activityLog = await serviceInjections.activityLogService.getActivityLogByRecordId(action.auxillaryData.ExistingRecords.RecordId, null, true);
        if (!activityLog?.Id) {
          throw new DependantSyncActionException(activityLog);
        }
        action.params.activityLogId = activityLog.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ApproveTime>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ApproveTime>) => {
      await serviceInjections.timeSyncService.onApproveTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.ReturnTime]: {
    id: SyncActionTypeId.ReturnTime,
    description: 'Return Time',
    url: environment.timeApiUrl + '/time/activity-logs/{activityLogId}/return',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityLogService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.SubmitTime>) => {
      if (!action.params.activityLogId) {
        const activityLog = await serviceInjections.activityLogService.getActivityLogByRecordId(action.auxillaryData.ExistingRecords.RecordId, null, true);
        if (!activityLog?.Id) {
          throw new DependantSyncActionException(activityLog);
        }
        action.params.activityLogId = activityLog.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ReturnTime>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.ReturnTime>) => {
      await serviceInjections.timeSyncService.onReturnTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.DeleteTime]: {
    id: SyncActionTypeId.DeleteTime,
    description: 'Delete Time',
    url: environment.timeApiUrl + '/time/time-records/{timeRecordId}/delete',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.TimeRecordService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.DeleteTime>) => {
      if (!action.params.timeRecordId) {
        const timeRecord = await serviceInjections.timeRecordService.getTimeRecordByRecordId(action.auxillaryData.ExistingTimeRecord.RecordId, null, true);
        if (!timeRecord?.Id) {
          throw new DependantSyncActionException(timeRecord);
        }
        action.params.timeRecordId = timeRecord.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteTime>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteTime>) => {
      await serviceInjections.timeSyncService.onDeleteTimeFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.DeleteNotableActivity]: {
    id: SyncActionTypeId.DeleteNotableActivity,
    description: 'Delete Notable Activity',
    url: environment.timeApiUrl + '/time/notable-activities/{activityId}/delete',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.DeleteNotableActivity>) => {
      if (!action.params.activityId) {
        const activity = await serviceInjections.activityService.getActivityByRecordId(action.auxillaryData.ExistingActivity.RecordId, null, true);
        if (!activity?.Id) {
          throw new DependantSyncActionException(activity);
        }
        action.params.activityId = activity.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteNotableActivity>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteNotableActivity>) => {
      await serviceInjections.timeSyncService.onDeleteNotableActivityFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.CreateOdometerReading]: {
    id: SyncActionTypeId.CreateOdometerReading,
    description: 'Create Odometer Reading',
    url: environment.timeApiUrl + '/time/odometer-reading',
    method: HttpMethod.POST,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.ActivityLogService, ServiceNames.OdometerReadingService, ServiceNames.OdometerReadingMediaService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.CreateOdometerReading>) => {
      await serviceInjections.timeSyncService.onCreateOdometerReadingDoBefore(action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateOdometerReading>) => {
      await serviceInjections.timeSyncService.onCreateOdometerReadingSuccess(action.auxillaryData, action.response);
     },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.CreateOdometerReading>) => {
      await serviceInjections.timeSyncService.onCreateOdometerReadingFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.UpdateOdometerReading]: {
    id: SyncActionTypeId.UpdateOdometerReading,
    description: 'Update Odometer Reading',
    url: environment.timeApiUrl + '/time/odometer-readings/{odometerReadingId}',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.OdometerReadingService, ServiceNames.ActivityLogService, ServiceNames.OdometerReadingMediaService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.UpdateOdometerReading>) => {
      await serviceInjections.timeSyncService.onUpdateOdometerReadingDoBefore(action);
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateOdometerReading>) => {},
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.UpdateOdometerReading>) => {
      await serviceInjections.timeSyncService.onUpdateOdometerReadingFailure(action.auxillaryData);
    },
  },
  [SyncActionTypeId.DeleteOdometerReading]: {
    id: SyncActionTypeId.DeleteOdometerReading,
    description: 'Delete Odometer Reading',
    url: environment.timeApiUrl + '/time/odometer-readings/{odometerReadingId}/delete',
    method: HttpMethod.PATCH,
    attemptTimeout: 30,
    maxAttempts: 3,
    serviceDependencies: [ServiceNames.TimeSyncService, ServiceNames.OdometerReadingService],
    doBefore: async (serviceInjections: ServiceInjections, action: SavedSyncAction<SyncActionTypeId.DeleteOdometerReading>) => {
      if (!action.params.odometerReadingId) {
        const odometerReading = await serviceInjections.odometerReadingService.getOdometerReadingByRecordId(action.auxillaryData.ExistingOdometerReading.RecordId, null, true);
        if (!odometerReading?.Id) {
          throw new DependantSyncActionException(odometerReading);
        }
        action.params.odometerReadingId = odometerReading.Id;
      }
    },
    onSuccess: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteOdometerReading>) => { },
    onFailure: async (serviceInjections: ServiceInjections, action: CompletedSyncAction<SyncActionTypeId.DeleteOdometerReading>) => {
      await serviceInjections.timeSyncService.onDeleteOdometerReadingFailure(action.auxillaryData);
    },
  },
};
